import React from "react";
import { AnimatedCounter } from "../components/AnimatedCounter";
import { Navigation } from "../components/Navigation";
import { useCounter } from "../hooks/useCounter";
import { COPY } from "../constants/copy";

interface CounterIntroProps {
  onNext: () => void;
  onPrevious: () => void;
}

export const CounterIntro: React.FC<CounterIntroProps> = ({
  onNext,
  onPrevious,
}) => {
  const { count } = useCounter(60, 2500);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-warmWhite dark:bg-darkBg transition-colors duration-400">
      <div className="max-w-md text-center space-y-12">
        <AnimatedCounter count={count} />

        <div className="space-y-4">
          <p className="text-lg text-deepCharcoal dark:text-darkText whitespace-pre-line leading-relaxed">
            {COPY.counter.message}
          </p>
        </div>

        <Navigation
          onNext={onNext}
          onPrevious={onPrevious}
          nextLabel={COPY.counter.button}
          showPrevious={true}
        />
      </div>
    </div>
  );
};
